module.exports = __webpack_public_path__ + "static/scale-model-of-white-house-east-wing-in-alexandria-virginia-3bfef52b8eca943308ccd7606faaa449.png";